export class DateRange {
	constructor(
		public startDate: Date,
		public endDate: Date
	) {}
}
